import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { CommonModule, DOCUMENT, NgClass } from '@angular/common';
import { CategoriesDataInterface } from 'src/_lib/interfaces/category.interface';
import { Common } from 'src/_lib/interfaces/common.interface';
import { CategoryService } from 'src/_lib/service/category.service';
import { environment } from 'src/environments/environment.prod';
import { TopSellersService } from 'src/_lib/service/top-sellers.service';
import { Router, RouterLink } from '@angular/router';
import { HeaderService } from 'src/_lib/service/header.service';
import { HeaderMenuData } from 'src/_lib/interfaces/header.interface';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { MatDialog } from '@angular/material/dialog';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { SearchByVehicleService } from 'src/_lib/service/search-by-vehicle.service';
import { ShopByVehicleComponent } from "src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component";
import { removeBackslash } from 'src/_lib/pipes/removebackslash.pipe';
import { BrowserService } from 'src/_lib/service/browser.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-header-sidebar-menu',
  templateUrl: './header-sidebar-menu.component.html',
  styleUrls: ['./header-sidebar-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, ShopByVehicleComponent, removeBackslash, NgClass]
})
export class HeaderSidebarMenuComponent implements OnInit, AfterViewInit {
  isSubMenuOpen = false;
  selectedCategoryTitle = '';
  selectedCategoryKey: number;
  cartItems: number = null;
  chTheme2 = environment.chTheme2;
  chTheme5 = environment.chTheme5;
  chTheme4 = environment.chTheme4;
  chTheme9 = environment.chTheme9;
  categoryData = [];
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  imgBasePath: string = environment.imageBasePath;
  closeIcon: string = environment.closeIcon;
  subCategoryList: any;
  topSellersData: any;
  menuData: HeaderMenuData[] = [];
  leftMenu: HeaderMenuData[] = [];
  rightMenu: HeaderMenuData[] = [];
  product_key: number;
  product_name: string;
  product_sku: string;
  userName: string;
  categoryStack: any[] = [];
  headerdata: any;
  showCategoryDetails: boolean = false;
  showServiceSubDropdownFlag: boolean = false;
  wishItems: number;
  vehicle_name: string;
  isSearchByVehicleDisabled: boolean = false;
  contact: string = environment.contact_no;
  formatted_contact: string = this.contact.replace(
    /(\d{3})(\d{3})(\d{4})/,
    '$1-$2-$3',
  );
  showTopSellerCat: boolean = environment.sidebar_top_seller_cat;
  showBrandBtn: boolean = environment.sidebar_brand_btn;
  showPromoBtn: boolean = environment.sidebar_promo_btn;
  private showListener: any;
  private hideListener: any;
  private openPopupListener: any;
  private globalHideListener: any;

  @Output() sidebarState = new EventEmitter<boolean>();

  constructor(
    private categoryHttp: CategoryService,
    private appConstants: AppConstants,
    private topSellers: TopSellersService,
    private headerHttp: HeaderService,
    private router: Router,
    private comm: CommunicationService,
    private renderer: Renderer2,
    public dialog: MatDialog,
    private commonService: CommanpageService,
    private searchByVehicleService: SearchByVehicleService,
    private browser: BrowserService,
    private dynamicThemeClassService: DynamicThemeClassService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }  

  ngOnInit(): void {
    this.comm.showVehicleButton.subscribe(() => {
      const vehicleBtnData = this.commonService.isSearchByVehicleDisabled()
      this.isSearchByVehicleDisabled = vehicleBtnData?.header_sidebar;
    });
    this.getuserName();
    this.comm.vehicleFormSubject.subscribe((form) => {
      if (form !== 'null') {
        this.getTopSellersData();
        this.loadCategories();
      } else {
        this.getTopSellersData();
        this.loadCategories();
      }
    });
    this.vehicle_name = this.browser.localStorage?.getItem('vehiclename') || '';
    this.comm.vehiclenameSubject.subscribe((name) => {
      this.vehicle_name = name;
    });
    this.getMenuData();
    this.getheaderList();
    this.getOrderItems();
    this.getWishItems();
  }

  getuserName() {
    this.comm.username$.subscribe((name) => {
      this.userName = name ? name : null;
    });
  }

  getOrderItems(): void {
    const previousItemCount = this.cartItems;
    this.cartItems = +this.browser.localStorage?.getItem('ItemCount') || 0;
    // Check if an item was recently added by looking for the 'ItemRecentlyAdded' flag
    if (
      this.browser.localStorage?.getItem('ItemRecentlyAdded') &&
      this.cartItems > previousItemCount
    ) {
      this.browser.localStorage?.removeItem('ItemRecentlyAdded');
    }
    // Update subscription to check for item count changes
    this.comm.itemCount.subscribe(() => {
      const newItemCount = +this.browser.localStorage?.getItem('ItemCount') || 0;
      if (
        this.browser.localStorage?.getItem('ItemRecentlyAdded') &&
        newItemCount > this.cartItems
      ) {
        this.browser.localStorage?.removeItem('ItemRecentlyAdded');
      }
      this.cartItems = newItemCount;
    });
  }

  getWishItems(): void {
    this.wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    this.comm.wishlistCount.subscribe((value) => {
      this.wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    });
  }

  getMenuData(): void {
    this.headerHttp.headerMenuList().subscribe({
      next: (response: Common<HeaderMenuData>) => {
        const menuList = response[0]?.data || [];
        this.leftMenu = menuList.filter((m) => m.menu_type === 'left menu');
        this.rightMenu = menuList.filter((m) => m.menu_type === 'right menu');
      },
      error: (err) => {
        console.error('Menu API error', err);
      },
    });
  }

  getheaderList(): void {
    this.headerHttp.headerList().subscribe((data) => {
      this.headerdata = data[this.firstObj].data;
    });
  }

  ngAfterViewInit() {
    if (!this.browser.isBrowser) return;
    const doc = this.browser.doc;
    const win = this.browser.window;
    if (!doc || !win) return;
    const offcanvas = import('bootstrap').then((bootstrap) => bootstrap.Offcanvas);
    const sidebarEl = doc.getElementById('mobileSidebar');
    const bodyEl = doc.getElementById('myOffcanvasBody');
    // ✅ SHOW SIDEBAR
    if (sidebarEl) {
      this.showListener = () => {
        bodyEl?.scrollTo({ top: 0 });
        this.sidebarState.emit(true);
        this.renderer.setStyle(doc.documentElement, 'overflow', 'hidden');
        this.showServiceSubDropdownFlag = false;
      };
      sidebarEl.addEventListener('show.bs.offcanvas', this.showListener);
      // ✅ HIDE SIDEBAR
      this.hideListener = () => {
        this.sidebarState.emit(false);
        this.renderer.removeStyle(doc.documentElement, 'overflow');
        doc.querySelectorAll('.offcanvas-backdrop').forEach((el: any) => {
          el.remove();
        });
        doc.body.classList.remove('offcanvas-backdrop', 'show', 'modal-open');
      };
      sidebarEl.addEventListener('hide.bs.offcanvas', this.hideListener);
    }

    // ✅ OPEN ACCOUNT POPUP
    this.openPopupListener = () => {
      this.renderer.setStyle(doc.documentElement, 'overflow', 'hidden');
    };
    win.addEventListener('open-account-popup', this.openPopupListener);
    // ✅ GLOBAL HIDE
    this.globalHideListener = () => {
      this.renderer.removeStyle(doc.documentElement, 'overflow');
    };
    win.addEventListener('hide.bs.offcanvas', this.globalHideListener);
  }

  onImageError(event: any) {
    event.target.src = `${this.imgBasePath}logomobile.webp`;
  }

  getTopSellersData(): void {
    this.topSellers.topSellingCategories().subscribe((response) => {
      const res = response?.[0];
      if (res?.success && Array.isArray(res.data)) {
        this.topSellersData = res.data;
      } else {
        this.topSellersData = [];
      }
    });
  }

  loadCategories(): void {
    this.categoryHttp.allcategoriesList().subscribe({
      next: (response: any) => {
        if (response[this.firstObj]?.success === true) {
          this.categoryData = response[this.firstObj].data.parentCats;
          this.categoryData.sort((a: any, b: any) =>
            a.name.localeCompare(b.name),
          );
        }
      },
    });
  }

  openSubCategoryData(category: any): void {
    this.categoryHttp
      .subCategoriesList(category.category_key)
      .subscribe((response) => {
        this.isSubMenuOpen = true;
        this.selectedCategoryTitle = category.name;
        const data = response[0].data;
        if (data[0].category_key) {
          let bodyEl: any;
          if (typeof document !== 'undefined') {
            bodyEl = document.getElementById('myOffcanvasBody');
          }
          bodyEl.scrollTo({ top: 0 });
          this.openSubCategory({
            name: category.name,
            category_key: category.category_key,
            parent_category_key: category.category_key,
            all_descendant_categories: data,
          });
        } else {
          this.subCategoryList = null;
          this.isSubMenuOpen = false;
          this.selectedCategoryTitle = '';
          this.showCategoryDetails = false;
          this.categoriesRedirection(category);
        }
      });
  }

  openSubCategory(category: any): void {
    this.isSubMenuOpen = true;
    this.categoryStack.push({
      list: this.subCategoryList,
      title: this.selectedCategoryTitle,
    });
    if (
      category.all_descendant_categories &&
      category.all_descendant_categories?.length == 0
    ) {
      this.categoriesRedirection(category);
    }
    this.selectedCategoryTitle = category.name;
    this.subCategoryList = category?.all_descendant_categories.sort(
      (a: any, b: any) => a.name.localeCompare(b.name),
    );
  }

  closeSubCategory(): void {
    const previous = this.categoryStack.pop();
    if (
      !previous ||
      previous.list == undefined ||
      previous.list?.length == 0 ||
      previous.list == null
    ) {
      this.isSubMenuOpen = false;
      this.showCategoryDetails = false;
      this.selectedCategoryTitle = '';
      this.subCategoryList = null;
      return;
    }
    this.subCategoryList = previous.list;
    this.showCategoryDetails = false;
    this.selectedCategoryTitle = previous.title || '';
  }

  async productRedirection(event: any): Promise<void> {
    this.subCategoryList = null;
    this.showCategoryDetails = false;
    this.isSubMenuOpen = false;
    this.selectedCategoryTitle = '';
    this.product_key = event.product_key;
    this.product_name = event.name;
    this.product_sku = event.sku;
    let sidebarEl: any;
    if (typeof document !== 'undefined') {
      sidebarEl = this.document.getElementById('mobileSidebar');
    }
    if (sidebarEl) {
      const bootstrap = await import('bootstrap');
      const OffcanvasBootsrap = bootstrap.Offcanvas;
      const offcanvas =
        OffcanvasBootsrap.getInstance(sidebarEl) || new OffcanvasBootsrap(sidebarEl);
      offcanvas.hide();
      sidebarEl.addEventListener(
        'hidden.bs.offcanvas',
        () => {
          const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
          const productKey = event.product_key;
          const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
          updatedProducts.unshift(productKey);
          this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
          this.commonService.productRedirection(
            this.product_name,
            this.product_key,
          );
        },
        { once: true },
      );
    } else {
      const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
      const productKey = event.product_key;
      const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
      updatedProducts.unshift(productKey);
      this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
      this.commonService.productRedirection(
        this.product_name,
        this.product_key,
      );
    }
  }

  getLoggedInUserName(): string | null {
    this.userName = this.browser.localStorage?.getItem('Username');
    return this.userName;
  }

  onAccountButton(): void {
    const user = this.userName;
    if (user) {
      this.router.navigate(['/my-account']);
    } else {
      this.router.navigate(['/customer-login']);
    }
  }

  onOrderStatus() {
    const user = this.userName;
    if (user) {
      this.router.navigate(['/track-order-details']);
    } else {
      this.router.navigate(['/customer-login']);
    }
  }

  openVechicleSearchPopup(): void {
    if (!this.vehicle_name) {
      this.dialog.open(SearchByVehicleComponent, {
        width: '600px',
        panelClass: 'search-by-vehicle-dialog',
      });
    } else {
      this.searchByVehicleService.clearVehicleSearch();
    }
  }

  getMenuImage(menuName: string): string {
    const imageMap: { [key: string]: string } = {
      'My Cart': `${this.commonImagePath}cart.webp`,
      'My Account': `${this.commonImagePath}user.webp`,
      'My Garage': `${this.commonImagePath}my_garage_icon.webp`,
      'Order Status': `${this.commonImagePath}order_status.webp`,
      'Wish List': `${this.commonImagePath}wishlist_icon.webp`,
      'Help Center': `${this.commonImagePath}helpcenter_img.webp`,
      'Customer Support': `${this.commonImagePath}helpcenter_img.webp`,
      'News & Events': `${this.commonImagePath}newsreport_icon.webp`,
      'Tune Talk': `${this.commonImagePath}newsreport_icon.webp`,
      'Blog': `${this.commonImagePath}newsreport_icon.webp`,
      'BMP Talk': `${this.commonImagePath}newsreport_icon.webp`,
      About: `${this.commonImagePath}about.webp`,
      Builds: `${this.commonImagePath}photo_icon.webp`,
      Gallery: `${this.commonImagePath}photo_icon.webp`,
      Galleries: `${this.commonImagePath}photo_icon.webp`,
      Videos: `${this.commonImagePath}video_icon.webp`,
      Services: `${this.commonImagePath}services.webp`,
      'Reprogramming Services': `${this.commonImagePath}services.webp`,
      Careers: `${this.commonImagePath}career11.webp`,
      'Contact Us': `${this.commonImagePath}mail_icon.webp`,
      Dashboard: `${this.commonImagePath}dashboard_icon.webp`,
      Profile: `${this.commonImagePath}profile_icon.webp`,
      'My Reviews': `${this.commonImagePath}review_icon.webp`,
      'My Photos': `${this.commonImagePath}photo_icon.webp`,
      'My Videos': `${this.commonImagePath}video_icon.webp`,
      'My Community': `${this.commonImagePath}community_icon.webp`,
      Notification: `${this.commonImagePath}notifications_icon.webp`,
      Orders: `${this.commonImagePath}order_status.webp`,
      'Orders & Return': `${this.commonImagePath}order_status.webp`,
      'The Engine Room Blog': `${this.commonImagePath}services.webp`,
    };
    return imageMap[menuName];
  }

  onLogout() {
    this.router.navigate(['/logout']);
  }

  async categoriesRedirection(categories: CategoriesDataInterface): Promise<void> {
    this.subCategoryList = null;
    this.showCategoryDetails = false;
    this.isSubMenuOpen = false;
    this.selectedCategoryTitle = '';
    let sidebarEl: any;
    if (typeof document !== 'undefined') {
      sidebarEl = this.document.getElementById('mobileSidebar');
    }
    if (sidebarEl) {
      const bootstrap = await import('bootstrap');
      const OffcanvasBootsrap = bootstrap.Offcanvas;
      const offcanvas =
        OffcanvasBootsrap.getInstance(sidebarEl) || new OffcanvasBootsrap(sidebarEl);
      offcanvas.hide();
      sidebarEl.addEventListener(
        'hidden.bs.offcanvas',
        () => {
          this.commonService.categoryRedirection(
            categories.name,
            categories.category_key,
          );
        },
        { once: true },
      );
    } else {
      this.commonService.categoryRedirection(
        categories.name,
        categories.category_key,
      );
    }
  }

  brokenImageError(event: any) {
    event.target.src = `${this.commonImagePath}image_not_found.webp`;
  }

  onClick(navLink: string, navname: string): void {
    if (navLink.includes('service/Town-Haul-Services')) {
      this.router.navigate([navLink], {
        queryParams: { section: navname },
      });
    }
  }

  showServiceSubDropdown() {
    this.showServiceSubDropdownFlag = !this.showServiceSubDropdownFlag;
  }

  ngOnDestroy() {
    if (!this.browser.isBrowser) return;
    const doc = this.browser.doc;
    const win = this.browser.window;
    if (!doc || !win) return;
    const sidebarEl = doc.getElementById('mobileSidebar');
    if (sidebarEl) {
      sidebarEl.removeEventListener('show.bs.offcanvas', this.showListener);
      sidebarEl.removeEventListener('hide.bs.offcanvas', this.hideListener);
    }
    win.removeEventListener('open-account-popup', this.openPopupListener);
    win.removeEventListener('hide.bs.offcanvas', this.globalHideListener);
  }
}